import React from 'react';
import {
    Eye as EyeIcon,
    EyeOff as EyeOffIcon,
    Edit as EditIcon,
    Delete as DeleteIcon,
    MinusCircle as MinusCircleIcon,
    BookOpen as OpenIcon,
    Search as AdjacentIcon
} from 'react-feather';
import {Button} from "@material-ui/core";
import FlagIcon from "../FlagIcon";
import {formatDateTime, formatSeconds} from "../../utils/Formatter";
import Alert from "@material-ui/lab/Alert";
import InInIcon from "../../assets/icons/in_in_icon.svg";
import OutOutIcon from "../../assets/icons/out_out_icon.svg";
import NoInIcon from "../../assets/icons/no_in_icon.svg";
import UndefinedDirectionIcon from "../../assets/icons/undef_icon.svg";
import {EditableNumberPlate} from "../EditableNumberPlate";

export const ActionButtonTypes = { EDIT: "EDIT", DELETE: "DELETE", VIEW: "VIEW", "ADJACENT_EVENTS": "ADJACENT_EVENTS" };

const selectTemplateForButtonType = (type) => {
    switch (type) {
        case ActionButtonTypes.EDIT:
            return <EditIcon color="green" />;
        case ActionButtonTypes.DELETE:
            return <DeleteIcon color="red" />;
        case ActionButtonTypes.VIEW:
            return <OpenIcon />;
        case ActionButtonTypes.ADJACENT_EVENTS:
            return <AdjacentIcon />;
    }
}

export const BooleanGridColumnType = {
  type: 'string',
  width: 130,
  renderCell: ({ value }) => {
      return value ? <EyeIcon color="green" /> : <EyeOffIcon color="grey" /> ;
  }
};

export const ActionsGridColumnType = {
    type: 'string',
    width: 200,
    sortable: false
};

export const ActionButtons = (buttons) => {

    const templates = buttons.map(({type, ...rest}) => {
        return { type: type, button: selectTemplateForButtonType(type), ...rest };
    });

    return Object.assign(ActionsGridColumnType, {
        renderCell: (cell) => {
            return <div>{templates.map(({onClick, button, type, visibilityCondition, ...rest}, i) => {
                return (!visibilityCondition || visibilityCondition && visibilityCondition(cell.row)) ? (
                    <ActionButton key={i} onClick={onClick} content={button} row={cell.row} {...rest}  />
                ) : ''

            })}</div>
        }
    });
};

export const NumberPlateColumnType = {
    width: 140,
    sortable: false,
    renderCell: (cell) => {
        return <span>{cell.value} <FlagIcon code={cell.row.NumberPlateOrigin.toLowerCase()} size={"lg"}/></span>;
    }
};

export const EditableNumberPlateColumnType = ({onChange}) => {

    return {
        width: 140,
        sortable: false,
        renderCell: (cell) => {
            return <EditableNumberPlate id={cell.row.Id} value={cell.value}
                                        country={cell.row.NumberPlateOrigin.toLowerCase()} onChange={onChange}/>;
        }
    }
};

export const CameraEventDirectionColumnType = ({onClick}) => {

    return {
        width: 80,
        sortable: false,
        renderCell: (cell) => {
            return <span onDoubleClick={e => onClick(cell.row)}>{cell.value}</span>;
        }
    }
};

export const EventDateColumnType = {
    sortable: false,
    width: 180,
    renderCell: ({value}) => {
        return formatDateTime(value)
    }
};

export const NumberPlateImageUrlColumnType = {
   width: 200,
    sortable: false,
    renderCell: ({ value }) => {
        return value ? <img src={value} style={{maxHeight: 250, maxWidth: 120}} /> : '';
    }
};

export const DurationColumnType = {
    width: 200,
    sortable: false,
    renderCell: ({ value, row }) => {
        const renderValue = value > 0 ? formatSeconds(value) : '';
        if (row.Suspicious) {
            return (<Alert severity="error">{renderValue}</Alert>);
        }
        return renderValue;
    }
};

export const CameraEventSuspiciousColumnType = {
    width: 100,
    sortable: false,
    renderCell: ({ value, row }) => {
        if (row.Suspicious) {

            switch (row.Suspicious) {
                case 10:
                    return ( <img src={UndefinedDirectionIcon} />);
                case 20:
                    return (<img src={InInIcon} />);
                case 21:
                    return (<img src={OutOutIcon} />);
                case 22:
                    return (<img src={NoInIcon} />);
                default:
                    return (<MinusCircleIcon color="red" />);
            }
        }
        return '';
    }
};

export const buildActionButton = (type, title, handler, visibilityCondition) => {
    return { type: type, onClick: handler, title: title, visibilityCondition: visibilityCondition };
}

export const ParkingEventLinkColumnType = ({onClick}) => {

    return {
        width: 80,
        sortable: false,
        renderCell: (cell) => {
            return cell.value && <a href={"#"} onClick={e => onClick(cell.row)}>{cell.value}</a>;
        }
    }
};

export const ActionButton = ({onClick, content, row, ...rest}) => {
    return (<Button onClick={e => {
        onClick(row);
    } } {...rest}>{content}</Button>);
}